import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/** Redirects `/path/` → `/path` so URLs match the canonical form. */
const TrailingSlashRedirect: React.FC = () => {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname.length > 1 && pathname.endsWith('/')) {
      navigate(`${pathname.replace(/\/+$/, '')}${search}${hash}`, { replace: true });
    }
  }, [pathname, search, hash, navigate]);

  return null;
};

export default TrailingSlashRedirect;
